<template>
  <section id="exchange">
    <exchange-list
      v-if="incomingExchanges.length || outgoingExchanges.length"
      @reShareExchange="reShareExchange"
    ></exchange-list>
    <div v-else class="empty-dashboard">
      <div>
        <h3>{{ $t("dashboard-no-files") }}</h3>
        <p
          class="pointer"
          @click="showUploadModal"
          v-html="$t('dashboard-no-files-upload')"
        ></p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ExchangeList from "@/views/modules/dashboard/components/exchange/ExchangeList";

export default {
  name: "Exchange",
  components: {
    ExchangeList
  },
  computed: {
    ...mapState("exchange", ["incomingExchanges", "outgoingExchanges"])
  },
  methods: {
    ...mapActions("common", ["showUploadModal"]),
    reShareExchange(id) {
      this.$emit("reShareExchange", id);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../../../assets/styles/variables";

section {
  flex: 2;
}

.empty-dashboard {
  background: $light-gray;
  border: 1px solid $middle-gray;
  border-radius: $radius;
  justify-content: center;
  align-items: center;
  display: flex;
  color: $placeholder-color;
  text-align: center;
  height: 100%;
  margin: 30px;
}

#exchange {
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: calc(100vh - 87px);
  min-height: 713px;
  /deep/ .exchange-list {
    flex: 1;
  }
}
</style>
